export enum DocumentUploadMode {
	LeaveCase = 1,
	Employer = 2,
	Employee = 3,
	Template = 4,
	Recert = 5
}